module.exports = __webpack_public_path__ + "media/images/lb/164-215d1bcfa147cfb6583bc0c588959070.svg";